module.exports = __webpack_public_path__ + "img/persona2.3d0cf0e4.webp";